import { makeStyles } from "@material-ui/core/styles";
import getCommonStyles from "./_common";

const useWhyChooseUs = makeStyles((theme) => ({
  ...getCommonStyles(theme),
  root: {
    background: "transparent",
    ...getCommonStyles(theme).sectionContainer,
    position: "relative",
    overflow: "hidden",
    padding: theme.spacing(12, 0, 12),
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(8, 0, 8),
    },
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background:
        "radial-gradient(circle at 20% 80%, rgba(0, 212, 170, 0.12) 0%, transparent 45%), radial-gradient(circle at 80% 20%, rgba(102, 126, 234, 0.12) 0%, transparent 45%)",
      pointerEvents: "none",
    },
  },
  sectionTitle: {
    ...getCommonStyles(theme).sectionTitle,
    fontFamily: '"vester-medium", "Montserrat", "Inter", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
    lineHeight: 1.08,
    background: 'linear-gradient(135deg, #ffffff 0%, #cdfaf1 45%, #6fe9d6 100%)',
    backgroundClip: 'text',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    marginBottom: theme.spacing(5),
    fontSize: '3rem',
    [theme.breakpoints.down("sm")]: {
      fontSize: '2rem',
    },
  },
  sectionDescription: {
    ...getCommonStyles(theme).sectionDescription,
    fontFamily: '"Montserrat", "Inter", "Segoe UI", sans-serif',
    color: '#b5c3d3',
    fontSize: '1.15rem',
    lineHeight: 1.9,
    [theme.breakpoints.down("sm")]: {
      fontSize: '1rem',
    },
  },
}));
export default useWhyChooseUs;
